"use client";

import {
  ScrollRevealMuted,
  ScrollRevealText,
} from "@/components/ui/scroll-reveal-text";

/** Two-tone customer quote reveal — lead animates to grey-950, trail stays grey-400. */
export function CustomerQuoteReveal({
  quoteLead,
  quoteTrail,
}: {
  quoteLead: string;
  quoteTrail: string;
}) {
  return (
    <ScrollRevealText variant="light" as="span" className="text-balance">
      {quoteLead.trimEnd()}{" "}
      <ScrollRevealMuted className="text-grey-400">
        {quoteTrail}
      </ScrollRevealMuted>
    </ScrollRevealText>
  );
}
